import { render } from "./techDemand.vue?vue&type=template&id=987423b2&scoped=true"
import script from "./techDemand.vue?vue&type=script&lang=js"
export * from "./techDemand.vue?vue&type=script&lang=js"

import "./techDemand.vue?vue&type=style&index=0&id=987423b2&scoped=true&lang=css"

import exportComponent from "D:\\code\\vue\\gaoxinTech\\gaoxin_tech1\\gaoxintech\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-987423b2"]])

export default __exports__